module.exports = __webpack_public_path__ + "static/media/basis-grotesque-medium.f070d5c6.ttf";